module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_117-9e06c99386ea6938e77bf01a434e480e.png";